// analytics.js — Google Analytics 4 event helpers
// Replace G-XXXXXXXXXX in index.html with your real Measurement ID

export function gaEvent(eventName, params = {}) {
  if (typeof window.gtag !== 'function') return
  window.gtag('event', eventName, params)
}

// Page view — called automatically on route change via usePageTracking()
export function gaPageView(path, title) {
  if (typeof window.gtag !== 'function') return
  window.gtag('config', 'G-XXXXXXXXXX', {
    page_path: path,
    page_title: title,
  })
}

// Key events
export const ga = {
  // Writing
  publishPost: (postId, readTime) =>
    gaEvent('publish_post', { post_id: postId, read_time: readTime }),
  saveDraft: () =>
    gaEvent('save_draft'),

  // Reading
  openPost: (postId, title) =>
    gaEvent('open_post', { post_id: postId, post_title: title }),
  readComplete: (postId, readTime) =>
    gaEvent('read_complete', { post_id: postId, read_time: readTime }),
  savePost: (postId) =>
    gaEvent('save_to_reading_list', { post_id: postId }),
  sharePost: (postId) =>
    gaEvent('share_post', { post_id: postId }),

  // Engagement
  react: (postId, reactionType) =>
    gaEvent('react', { post_id: postId, reaction_type: reactionType }),
  comment: (postId) =>
    gaEvent('comment', { post_id: postId }),
  annotate: (postId) =>
    gaEvent('annotate', { post_id: postId }),
  writeResponse: (originalPostId) =>
    gaEvent('write_response', { original_post_id: originalPostId }),

  // Auth
  signUp: () => gaEvent('sign_up'),
  signIn: () => gaEvent('login'),

  // Navigation
  viewPrompts: () => gaEvent('view_prompts'),
  viewMasthead: () => gaEvent('view_masthead'),
  viewRecord: (writerId) => gaEvent('view_record', { writer_id: writerId }),
  viewProfile: (writerId) => gaEvent('view_profile', { writer_id: writerId }),

  // Export
  export: (format) => gaEvent('export_work', { format }),
}
